const API = "/api";

// ======================
// PRODUCTOS
// ======================

export async function getProducts() {
  const res = await fetch(`${API}/products/get.php`);

  if (!res.ok) throw new Error("Error al obtener productos");

  return await res.json();
}

export async function saveProduct(product: any) {
  const res = await fetch(`${API}/products/save.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(product),
  });

  if (!res.ok) throw new Error("Error al guardar producto");

  return await res.json();
}

export async function deleteProduct(id: number) {
  const res = await fetch(`${API}/products/delete.php?id=${id}`, {
    method: "DELETE",
  });

  if (!res.ok) throw new Error("Error al eliminar producto");

  return await res.json();
}

// ======================
// PROMOCIONES
// ======================

export async function getPromotions() {
  const res = await fetch(`${API}/promotions/get.php`);

  if (!res.ok) throw new Error("Error al obtener promociones");

  return await res.json();
}

export async function savePromotion(promotion: any) {
  const res = await fetch(`${API}/promotions/save.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(promotion),
  });

  if (!res.ok) throw new Error("Error al guardar promoción");

  return await res.json();
}

export async function deletePromotion(id: number) {
  const res = await fetch(`${API}/promotions/delete.php?id=${id}`, {
    method: "DELETE",
  });

  if (!res.ok) throw new Error("Error al eliminar promoción");

  return await res.json();
}

// ======================
// BLOG
// ======================

export async function getArticles() {
  const res = await fetch(`${API}/blog/get.php`);

  if (!res.ok) throw new Error("Error al obtener artículos");

  return await res.json();
}

export async function saveArticle(article: any) {
  const res = await fetch(`${API}/blog/save.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(article),
  });

  if (!res.ok) throw new Error("Error al guardar artículo");

  return await res.json();
}

export async function deleteArticle(id: number) {
  const res = await fetch(`${API}/blog/delete.php?id=${id}`, {
    method: "DELETE",
  });

  if (!res.ok) throw new Error("Error al eliminar artículo");

  return await res.json();
}

export async function toggleFeatured(id: number) {
  const res = await fetch(`${API}/blog/toggle_featured.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id }),
  });

  if (!res.ok)
    throw new Error("Error al actualizar artículo destacado");

  return await res.json();
}

// ======================
// DASHBOARD
// ======================

export async function getStats() {
  const res = await fetch(`${API}/dashboard/stats.php`);

  if (!res.ok) throw new Error("Error al obtener estadísticas");

  return await res.json();
}

